import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';

export const StyledCommunixBundle = styled.div`
  width: 100%;
  max-width: 400px;
  height: 203px;
  aspect-ratio: 1/1.31;
  position: relative;
  font-family: ${(props: any) => props.fontFamily};
  font-weight: bold;

  .container {
    width: 100%;
    height: 100%;
    max-height: 203px; // safari fix
    display: flex;
    flex-direction: column;

    border-radius: ${(props: any) => `${props.borderRadius || 7}px`};
    background: ${(props: any) =>
      createGradientOrSolid(props.bundleBorderColor)};

    .product {
      height: 100%;
      display: flex;
      flex-direction: column;
      padding: 2px;

      border-radius: ${(props: any) => `${props.borderRadius || 7}px`};
      background: ${(props: any) =>
        props.backgroundSrc
          ? `url("${props.backgroundSrc}")`
          : createGradientOrSolid(props.backgroundColor)};
      background-clip: content-box;
      background-size: cover;
      gap: 0;

      .badge-wrapper {
        max-height: 18px;
        min-height: calc(15% - 4px);
        position: absolute;
        width: 100%;
        top: 1px;
        height: 14px;

        .middle-badge {
          top: -4px;
          height: 14px;
          width: 69px;
          display: flex;
          align-items: center;
          justify-content: center;

          & > p {
            font-size: 10px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            margin-bottom: 0;
          }
        }
      }

      .amount {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 6px auto 0;
        color: ${(props: any) => props.productColor};
        text-shadow: 0 1px 1px #000;
        text-align: left;
        font-size: 18px;

        & > div {
          display: flex;
          align-items: center;
          flex-direction: column;
        }

        .stroked {
          font-size: 12px;
          position: relative;
          color: #e6594b;
          font-weight: 800;
          text-shadow: none;
          height: 14px;

          &::after {
            content: ' ';
            height: 2px;
            width: 110%;
            background: #e6594b;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%) rotate(10deg);
          }
        }

        img {
          height: 14px;
          aspect-ratio: 1/1;
          margin: 0 4px 0 0;
        }
      }

      .image {
        width: 52px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto 0;

        img {
          max-height: 48px;
          height: auto;
          width: 100%;
          object-fit: contain;
        }
      }

      .sub-products {
        position: absolute;
        right: 1px;
        bottom: 54px;

        .sub-product {
          &:last-child {
            margin-bottom: 0;
          }

          margin-bottom: 12px;
          width: 82px;
          height: 26px;
          border-bottom-left-radius: 13px;
          border-top-left-radius: 13px;
          background: ${(props: any) =>
            createGradientOrSolid(props.bundleBorderColor)};
          box-sizing: border-box;

          &--background {
            display: flex;
            align-items: center;
            position: relative;
            height: 100%;

            &:before {
              content: '';
              position: absolute;
              border-radius: 13px 0 0 13px;
              background: ${(props: any) =>
                props.backgroundSrc
                  ? `url("${props.backgroundSrc}")`
                  : createGradientOrSolid(props.backgroundColor)};
              background-clip: content-box;
              background-size: cover;
              box-sizing: border-box;
              width: 100%;
              height: 100%;
              padding: 2px;
            }

            &__amount {
              font-size: 12px;
              font-style: normal;
              font-weight: 800;
              line-height: normal;
              text-shadow: 0 1px 1px #000;
              z-index: 1;
              padding-left: 7px;
            }

            &__image {
              display: flex;
              align-items: center;
              width: 30px;
              height: 40px;
              position: absolute;
              right: 6px;
              bottom: -1px;

              .sub-image {
                max-height: 40px;
                height: auto;
                width: 100%;
                object-fit: contain;
              }
            }
          }
        }
      }
    }

    .ac-ribbon-badge--center {
      width: 100%;
      position: absolute;
      height: 16px;
      bottom: 36px;
    }

    .price {
      height: 35px;
      border-bottom-left-radius: ${(props: any) =>
        `${props.borderRadius - 2 || 7 - 2}px`};
      border-bottom-right-radius: ${(props: any) =>
        `${props.borderRadius - 2 || 7 - 2}px`};
      text-shadow: 0 5px 1px #004100;
      margin-top: auto;
      border-bottom: 5px solid #007300;

      .totalPrice {
        text-shadow: 0 2px 1px #004100;
        font-size: 16px;
        font-style: normal;
        font-weight: 800;
        line-height: normal;
        flex-wrap: wrap;
        justify-content: center;
        margin: auto;
        width: 100%;
        padding: 0 5px;

        .stroked {
          padding-left: 4px;
          width: 100%;
          text-shadow: none;
          margin-left: 0;
          margin-right: 0;
          font-size: 8px;
          font-style: normal;
          font-weight: 800;
          line-height: normal;
          text-decoration-line: line-through;
          text-decoration-color: #ff0000;
          text-decoration-thickness: 1px;
          justify-content: center;
          order: 1;
        }
      }
    }
  }

  @media (min-width: 800px) {
    .container {
      .product {
        .image {
          width: 72px;
          height: 66px;

          img {
            max-height: 66px;
          }
        }

        .price {
          .totalPrice {
            flex-wrap: nowrap;

            .stroked {
              width: auto;
              margin-left: 4px;
              font-size: 12px;
            }
          }
        }
      }

      .ac-ribbon-badge--center .ac-ribbon-badge {
        &__front {
          height: 16px;

          &__text {
            font-size: 10px;
          }
        }
      }

      .ac-ribbon-badge--center {
        .ribbon-edge {
          top: 16px;
        }
      }
    }
  }
` as any;
